(() => {
  document.querySelectorAll('[data-filter-toggle]').forEach((button) => {
    const target = document.getElementById(button.getAttribute('aria-controls'));
    if (!target) return;

    const setExpanded = (expanded) => {
      target.classList.toggle('hidden', !expanded);
      button.setAttribute('aria-expanded', String(expanded));
    };

    button.addEventListener('click', () => {
      setExpanded(button.getAttribute('aria-expanded') !== 'true');
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && button.getAttribute('aria-expanded') === 'true') {
        setExpanded(false);
        button.focus();
      }
    });
  });

  document.querySelectorAll('[data-collection-sort]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  });
})();
